import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';
import PromptLoginComponent from './component';

type PromptLoginModalProps = {
  onClose?: () => void;
  onHidePopup?: () => void;
  shouldRedirect?: boolean;
};

/**
 * Modal wrapper for PromptLogin to work with the new modal manager system
 * Bridges onClose (new modal system) with handleLoginSuccess (legacy PromptLogin API)
 */
const PromptLoginModal = ({ onClose, onHidePopup, shouldRedirect = true }: PromptLoginModalProps) => {
  const handleLoginSuccess = useCallback(() => {
    // Close the modal after successful login
    if (onClose) {
      onClose();
    } else if (onHidePopup) {
      onHidePopup();
    }
  }, [onClose, onHidePopup]);

  // PromptLogin needs Redux state - get it here and pass as props
  const isInitialSsrPage = useSelector((state: RootReduxState) => state.app.isInitialSsrPage);
  const pathname = useSelector((state: RootReduxState) => state.location.current.pathname);
  const user = useSelector((state: RootReduxState) => state.user);

  return (
    <PromptLoginComponent
      handleLoginSuccess={handleLoginSuccess}
      shouldRedirect={shouldRedirect}
      isInitialSsrPage={isInitialSsrPage}
      pathname={pathname}
      user={user}
    />
  );
};

export default PromptLoginModal;
